<!--
  BadgePill — pílula compacta em maiúsculas usada acima do título
  de cada seção (ex: "Por que a mudança?", "Conheça a tecnologia").

  Uso:
    <BadgePill>Perguntas frequentes</BadgePill>
    <BadgePill variante="destaque">Aviso</BadgePill>
    <BadgePill variante="azul">Novidade</BadgePill>
-->
<template>
  <span :class="['ds-badge-pill', variantClass]">
    <slot />
  </span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  variante: {
    type: String,
    default: 'default',
    validator: (v) => ['default', 'destaque', 'azul'].includes(v)
  }
})

const variantClass = computed(() => {
  if (props.variante === 'destaque') return 'ds-badge-pill--destaque'
  if (props.variante === 'azul') return 'ds-badge-pill--azul'
  return null
})
</script>
